import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';


const searchResultsUrl: string = '/busca';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  /**
   * CSCSATIVA-5524] - DESENVOLVIMENTO - AJUSTE NAVEGAÇÃO TECLADO RESULTADO PESQUISA CAIXA PESQUISA
   */
  private selectedTabindexSearchBar$: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  constructor(private router: Router) {
  }

  searchFor(searchTerm: string) {   
    let url: string = this.router.url;
    this.router.navigate([this.getCurrentLanguageFromURL(url) + searchResultsUrl, {'searchTerm': searchTerm}]);
  }

  private getCurrentLanguageFromURL(url: string): string {

    let terms: string[] = url.split('/');
    let isSpanish: number = terms.indexOf('es');
    let isEnglish: number = terms.indexOf('us');

    if (isSpanish > 0)
      return '/' + terms[isSpanish];
    if (isEnglish > 0)
      return '/' + terms[isEnglish];
    
    return '/br';
  }
  
  /**
   * CSCSATIVA-5524] - DESENVOLVIMENTO - AJUSTE NAVEGAÇÃO TECLADO RESULTADO PESQUISA CAIXA PESQUISA
   */
  getSearchbarTabindex() {
    return this.selectedTabindexSearchBar$.asObservable();
  }

  setSearchbarTabindex(tabindexSearchBar:number) {        
      this.selectedTabindexSearchBar$.next(tabindexSearchBar);
  }

}
